import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '@menu/components';

const Heading = ({ item, active }) => (
  <div className="heading">
    {item.link.url
      ? <Link item={item.link} active={active} />
      : <div className="no-link-heading"><span>{item.link.linkText}</span></div>}
  </div>
);

Heading.propTypes = {
  item: PropTypes.any.isRequired,
  active: PropTypes.bool.isRequired
};

export default Heading;
